import {
  SocialTwitterRoundIcon,
  SocialTwitterIcon,
  SocialInstagramIcon,
  SocialInstagramRoundIcon,
  SocialFacebookRoundIcon,
  SocialFacebookIcon,
  Logo,
} from '@hg/stylizator/icons'
import * as React from 'react'

export enum Icon {
  Logo = 'logo',
  FacebookRoundIcon = 'facebook-round-icon',
  TwitterRoundIcon = 'twitter-round-icon',
  InstagramRoundIcon = 'instagram-round-icon',
  FacebookIcon = 'facebook-icon',
  TwitterIcon = 'twitter-icon',
  InstagramIcon = 'instagram-icon',
}

export const selections = [
  { value: Icon.Logo, label: 'Logo' },
  { value: Icon.FacebookRoundIcon, label: 'Facebook round' },
  { value: Icon.TwitterRoundIcon, label: 'Twitter round' },
  { value: Icon.InstagramRoundIcon, label: 'Instagram round' },
  { value: Icon.FacebookIcon, label: 'Facebook' },
  { value: Icon.TwitterIcon, label: 'Twitter' },
  { value: Icon.InstagramIcon, label: 'Instagram' },
]

export const SelectionComponentMap: Record<Icon, React.ReactElement> = {
  [Icon.Logo]: <Logo />,
  [Icon.FacebookIcon]: <SocialFacebookIcon />,
  [Icon.TwitterIcon]: <SocialTwitterIcon />,
  [Icon.InstagramIcon]: <SocialInstagramIcon />,
  [Icon.FacebookRoundIcon]: <SocialFacebookRoundIcon />,
  [Icon.TwitterRoundIcon]: <SocialTwitterRoundIcon />,
  [Icon.InstagramRoundIcon]: <SocialInstagramRoundIcon />,
}
